import { useQuery } from '@tanstack/react-query'

export interface District {
  id: string
  name: string
  city?: {
    id: string
    name: string
  }
}

const API_URL =
  import.meta.env.VITE_EPC_API_URL ?? import.meta.env.REACT_APP_API_URL ?? ''

/**
 * Hook for fetching districts from a public endpoint without authentication
 * Used for the signup form where users aren't authenticated yet
 */
export const usePublicDistricts = (cityId?: string) => {
  return useQuery({
    queryKey: ['public-districts', { cityId }],
    queryFn: async () => {
      try {
        // Try the public endpoint first
        const publicUrl = cityId
          ? `${API_URL}/districts?cityId=${cityId}`
          : `${API_URL}/districts`

        const publicResponse = await fetch(publicUrl)

        if (publicResponse.ok) {
          return publicResponse.json() as Promise<string[]>
        } else {
          return [] as string[]
        }
      } catch (error) {
        console.error('Error fetching districts:', error)
        return [] as string[]
      }
    },
  })
}
